import {DialogTitle} from '@apps-common/ui-components';
import {
  DialogActions,
  DialogContent,
  DialogContentText,
  Paper,
} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const MiniDialog = ({closeToast, title, message, actions, ...props}) => {
  return (
    <Paper
      elevation={2}
      sx={{
        maxWidth: 535,
      }}
      {...props}
    >
      <DialogTitle title={title} onClose={closeToast} />
      <DialogContent>
        <DialogContentText component="div" color="textPrimary">
          {message}
        </DialogContentText>
      </DialogContent>
      {actions && <DialogActions>{actions}</DialogActions>}
    </Paper>
  );
};

MiniDialog.propTypes = {
  actions: PropTypes.array,
  message: PropTypes.oneOfType([PropTypes.object, PropTypes.node]),
  closeToast: PropTypes.func,
  title: PropTypes.string,
};

export default MiniDialog;
